import { Component } from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from './core/services/translation-loader.service';

import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FuseNavigationModel } from './navigation/navigation.model';
import { OtherNavigationModel } from './navigation/otherNavigation.model';
import { EmptyNavigationModel } from './navigation/emptyNavigation.model';

import { locale as navigationEnglish } from './navigation/i18n/en';
import { locale as navigationTurkish } from './navigation/i18n/tr';

@Component({
    selector: 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    role: string = '';
    constructor(
        private fuseNavigationService: FuseNavigationService,
        private fuseSplashScreen: FuseSplashScreenService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService
    ) {
        this.role = window.localStorage.getItem('role');
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');

        // Set the navigation model
        if (this.role == null) {
            this.fuseNavigationService.setNavigationModel(new EmptyNavigationModel());
        } else {
            this.fuseNavigationService.setNavigationModel(new FuseNavigationModel());
        }

        // this.fuseNavigationService.setNavigationModel(new FuseNavigationModel()); 
        this.translationLoader.loadTranslations(navigationEnglish, navigationTurkish);
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/app.component.ts